import React from "react";
import "../styles/Header.css";
import ProfilePic from '../assets/images/joeking-6.jpg';

function Header() {
    return (
        <div className="header" id="main">
            <div className="text-center text-white">
                <br />
                <h1>
                    im
                    <span className="text-info">only</span>
                    joeking
                </h1>
                <img className="profilepic" src={ProfilePic} alt="Joe King" />
                <h4>
                    Front-End Web Developer
                </h4>
                <br />
                <a href="https://drive.google.com/file/d/122qZFzPSKrtZpgLBQRHW1d9y71owE1Rq/view?usp=sharing">
                    <button type="button" className="btn btn-info btn-lg">
                            <i className="fa fa-download"></i>
                        Download Resume
                    </button>
                </a>
                <div className="social">
                    <a href="https://github.com/jking0186" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-github fa-2x m-2"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/joe-king-iii-60b9a3173/"
                        target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin fa-2x m-2"></i>
                    </a>
                    <a href="https://www.instagram.com/imonly_joeking/" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-instagram fa-2x m-2"></i>
                    </a>
                    <a href="https://twitter.com/imonly_joeking" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-twitter fa-2x m-2"></i>
                    </a>
                </div>
            </div>
        </div>
    )
};

export default Header;